import { createContext, useContext, ReactNode } from 'react';
import type { NavigationAdapter } from './types';

const NavigationContext = createContext<NavigationAdapter | null>(null);

export interface NavigationProviderProps {
  adapter: NavigationAdapter;
  children: ReactNode;
}

/**
 * Navigation Provider
 * Injects navigation adapter into the component tree
 */
export function NavigationProvider({ adapter, children }: NavigationProviderProps) {
  return <NavigationContext.Provider value={adapter}>{children}</NavigationContext.Provider>;
}

/**
 * Hook to access navigation adapter
 * @throws Error if used outside NavigationProvider
 */
export function useNavigationAdapter(): NavigationAdapter {
  const adapter = useContext(NavigationContext);

  if (!adapter) {
    return {
      useSearchParams: () => new URLSearchParams(),
      Link: ({ href, children, className }) => (
        <a href={href} className={className}>
          {children}
        </a>
      ),
    };
  }

  return adapter;
}
